export type { Dataset, DatasetSummary, DatasetQuestion } from "@/types/dashboard";

// Use relative URLs so they work in both dev (via Vite proxy) and production
export const API_BASE = "";

export interface Agent {
  name: string;
  path: string;
  display_name: string;
}

export interface Model {
  name: string;
  display_name: string;
  description: string;
  input_token_limit?: number;
  output_token_limit?: number;
}

/** Validation boundaries for the start-evaluation form. */
export const LIMITS = {
  REPEAT_MIN: 1,
  REPEAT_MAX: 10,
  WORKERS_MIN: 1,
  WORKERS_MAX: 10,
  LIMIT_MIN: 1,
};

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

/** "publishers/google/models/gemini-2.5-flash" -> "gemini-2.5-flash" (unless a display name is given). */
export function modelDisplayName(model: Pick<Model, "name" | "display_name"> | undefined, fallbackName = "") {
  const name = model?.name ?? fallbackName;
  return model?.display_name || (name.includes("/") ? name.split("/").pop() : name);
}

export const DIFFICULTY_LABELS: Record<string, string> = {
  easy: "Makkelijk",
  medium: "Gemiddeld",
  hard: "Moeilijk",
};
